//Sends a job click to the LinkedIn Conversions API function (lambda/linkedin-job-click)
export const trackJobClick = () => {
  const url = process.env.REACT_APP_JOB_CLICK_URL;
  if (!url) return;

  const body = JSON.stringify({
    eventId: window.crypto?.randomUUID?.(),
    //LinkedIn's click ID, added to the address when someone arrives from a LinkedIn ad
    liFatId: new URLSearchParams(window.location.search).get("li_fat_id"),
  });

  //sendBeacon keeps sending after the visitor has left for the job page
  if (!navigator.sendBeacon?.(url, body)) {
    fetch(url, { method: "POST", body, keepalive: true }).catch(() => {});
  }
};
